var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerformanceCurrency(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9994 20.3213C16.1475 20.3213 20.3208 16.148 20.3208 10.9999C20.3208 5.85181 16.1475 1.67847 10.9994 1.67847C5.85132 1.67847 1.67798 5.85181 1.67798 10.9999C1.67798 16.148 5.85132 20.3213 10.9994 20.3213Z",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6V7.42857",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.5715V16.0001",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85833 14.5713H12.0726C12.5462 14.5713 13.0004 14.3832 13.3353 14.0483C13.6702 13.7134 13.8583 13.2592 13.8583 12.7856C13.8583 12.312 13.6702 11.8578 13.3353 11.5229C13.0004 11.188 12.5462 10.9999 12.0726 10.9999H9.92976C9.45616 10.9999 9.00195 10.8118 8.66707 10.4769C8.33218 10.142 8.14404 9.68778 8.14404 9.21418C8.14404 8.74058 8.33218 8.28638 8.66707 7.95149C9.00195 7.6166 9.45616 7.42847 9.92976 7.42847H13.144",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceCurrency);
export default __webpack_public_path__ + "static/media/performance-currency.ecbfe9c9b8f96781b3a2f25fbba7c45a.svg";
export { ForwardRef as ReactComponent };